<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <ion-card style="box-shadow: none; display: flex; flex-direction: column; justify-content: space-between">
        <div>
          <ion-card-header>
            <PageNavigation page-precedente="activitee2" page-suivante="activitee4" :page-title="pageTitle" :show-left-arrow="true" :show-right-arrow="true" />
            <ion-card-subtitle>Ces six jeunes se demandent quels stands pourraient leur plaire.
              À toi de leur proposer deux ou trois stands à visiter</ion-card-subtitle>
          </ion-card-header>
          <ion-card-content>
            <div id="personAdviceContainer">
              <ion-slides pager="true" :options="slideOpts">
                <ion-slide>
                  <ion-card class="choices-card">
                    <img alt="Silhouette of mountains" class="img_bulles" src="../assets/personnages/bulle_1_choix_metier.png" />
                    <ion-card-content class="bottom-pers-pstl">
                      <div>
                        <img alt="Personnage numero 1" class="img_pesr" src="../assets/personnages/personnage_choix_1.png" />
                      </div>
                      <div>
                        <triple-choix-metier @change="handleNumberChange1"/>
                      </div>
                    </ion-card-content>
                  </ion-card>
                </ion-slide>
                <ion-slide>
                  <ion-card class="choices-card">
                    <img alt="Silhouette of mountains" class="img_bulles" src="../assets/personnages/bulle_2_choix_metier.png" />
                    <ion-card-content class="bottom-pers-pstl">
                      <div>
                        <img alt="Personnage numero 2" class="img_pesr" src="../assets/personnages/personnage_choix_2.png" />
                      </div>
                      <div>
                        <triple-choix-metier @change="handleNumberChange2"/>
                      </div>
                    </ion-card-content>
                  </ion-card>
                </ion-slide>
                <ion-slide>
                  <ion-card class="choices-card">
                    <img alt="Silhouette of mountains" class="img_bulles" src="../assets/personnages/bulle_3_choix_metier.png" />
                    <ion-card-content class="bottom-pers-pstl">
                      <div>
                        <img alt="Personnage numero 3" class="img_pesr" src="../assets/personnages/personnage_choix_3.png" />
                      </div>
                      <div>
                        <triple-choix-metier @change="handleNumberChange3"/>
                      </div>
                    </ion-card-content>
                  </ion-card>
                </ion-slide>
                <ion-slide>
                  <ion-card class="choices-card">
                    <img alt="Silhouette of mountains" class="img_bulles" src="../assets/personnages/bulle_4_choix_metier.png" />
                    <ion-card-content class="bottom-pers-pstl">
                      <div>
                        <img alt="Personnage numero 4" class="img_pesr" src="../assets/personnages/personnage_choix_4.png" />
                      </div>
                      <div>
                        <triple-choix-metier @change="handleNumberChange3"/>
                      </div>
                    </ion-card-content>
                  </ion-card>
                </ion-slide>
                <ion-slide>
                  <ion-card class="choices-card">
                    <img alt="Silhouette of mountains" class="img_bulles" src="../assets/personnages/bulle_5_choix_metier.png" />
                    <ion-card-content class="bottom-pers-pstl">
                      <div>
                        <img alt="Personnage numero 5" class="img_pesr" src="../assets/personnages/personnage_choix_5.png" />
                      </div>
                      <div>
                        <triple-choix-metier @change="handleNumberChange3"/>
                      </div>
                    </ion-card-content>
                  </ion-card>
                </ion-slide>
                <ion-slide>
                  <ion-card class="choices-card">
                    <img alt="Silhouette of mountains" class="img_bulles" src="../assets/personnages/bulle_6_choix_metier.png" />
                    <ion-card-content class="bottom-pers-pstl">
                      <div>
                        <img alt="Personnage numero 6" class="img_pesr" src="../assets/personnages/personnage_choix_6.png" />
                      </div>
                      <div>
                        <triple-choix-metier @change="handleNumberChange3"/>
                      </div>
                    </ion-card-content>
                  </ion-card>
                </ion-slide>
              </ion-slides>
              <ion-button expand="block" fill="solid" @click="this.$router.push('/tabs/metiers')">Aller voir les métiers</ion-button>
            </div>
          </ion-card-content>
        </div>
      </ion-card>
    </ion-content>
  </ion-page>
</template>

<script>

import {defineComponent} from "vue";
import {
  IonCard,
  IonCardContent,
  IonCardHeader, IonCardSubtitle,
  IonContent,
  IonPage, IonSlides, IonSlide, IonButton
} from "@ionic/vue";
import TripleChoixMetier from "@/components/TripleChoixMetier.vue";
import PageNavigation from "@/components/PageNavigation.vue";

export default defineComponent({
  components: {
    PageNavigation,
    IonButton,
    TripleChoixMetier,
    IonContent,
    IonCardSubtitle,
    IonCard,
    IonPage,
    IonCardHeader,
    IonCardContent,
    IonSlides,
    IonSlide
  },
  setup() {
    const slideOpts = {
      initialSlide: 0,
      speed: 300,
    };
    return { slideOpts };
  },
  data() {
    return {
      pageTitle: '3/4 A toi de jouer !',
      showNameAndDesc: false
    }
  },
  methods: {
    handleNumberChange1(newValues) {
      localStorage.setItem('numbers1', JSON.stringify(newValues));
    },
    handleNumberChange2(newValues) {
      localStorage.setItem('numbers2', JSON.stringify(newValues));
    },
    handleNumberChange3(newValues) {
      localStorage.setItem('numbers3', JSON.stringify(newValues));
    }
  }
})
</script>

<style scoped>

ion-card {
  box-sizing: border-box;
  margin: 0;
}

ion-card-header:not(.choices-card ion-card-header) {
  margin-top: 80px;
}

.img_bulles {
  max-height: 200px;
}

ion-card .choices-card {
  box-shadow: none;
  border-radius: 30px;
  width: 100%;
  margin: 5px;

  .bottom-pers-pstl {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    .img_pesr {
      max-height: 150px;
      margin: 0;
      position: absolute;
      bottom: 0;
      left: 10px;
    }
  }
}

ion-slides {
  overflow: visible;
}


</style>
